import CryptoJS from "crypto-js";

// Khóa bí mật và IV phải giống nhau trên cả hai phía mã hóa và giải mã
const secretKey = CryptoJS.enc.Utf8.parse("mySecretKey12345");

export const EncryptData = (data) => {
    const iv = CryptoJS.lib.WordArray.random(16); // Tạo IV ngẫu nhiên mỗi lần mã hóa
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey, { iv: iv, padding: CryptoJS.pad.Pkcs7 });
    const ivHex = iv.toString(CryptoJS.enc.Hex);
    const encryptedHex = encrypted.ciphertext.toString(CryptoJS.enc.Hex);
    return ivHex + encryptedHex; // Gắn IV vào trước ciphertext
}

